__turbopack_context__.v({
  "appDownloadContainer": "pb-Myq_appDownloadContainer",
  "buttonContainer": "pb-Myq_buttonContainer",
  "depopSticker": "pb-Myq_depopSticker",
  "downloadButtonContainer": "pb-Myq_downloadButtonContainer",
  "horizontalBreak": "pb-Myq_horizontalBreak",
  "horizontalBreakContainer": "pb-Myq_horizontalBreakContainer",
  "loginLink": "pb-Myq_loginLink",
  "modalBodyText": "pb-Myq_modalBodyText",
  "modalContainer": "pb-Myq_modalContainer",
  "modalTitle": "pb-Myq_modalTitle",
  "orText": "pb-Myq_orText",
  "signupLink": "pb-Myq_signupLink",
});
